const queryString = require('query-string');
import BreakpointsEnum from "./enums/breakpointsEnum";

$(function () {
    let App = window.App;
    App.guru = {};

    let $slides = $('section.questionnaire .slides');
    let $nextBtn = $('#nextBtn');
    let $resultBtn = $('#resultBtn');
    let $startCheckbox = $('#startToggle');

    let state = {
        step: 0,
        stepTotal: undefined,
        group: undefined,
    };

    const setCurrentSlide = function (group, slideNumber) {
        $slides.find('.slide').addClass('hidden');
        $slides.find(`.slide[data-group="${group}"]`).eq(slideNumber).removeClass('hidden');
    }

    const setCurrentGroup = function (group) {
        state.group = group;
        state.stepTotal = $slides.find(`.slide[data-group="${group}"]`).length;
    }

    const showStartSlide = function () {
        state.step = 0;
        state.group = undefined;
        state.stepTotal = undefined;
        setCurrentSlide(0, 0);
        showNextBtn();
        $('.answers .btn.btn-check').removeClass('active');
    }

    const showResultBtn = function () {
        $nextBtn.addClass('hidden');
        $resultBtn.removeClass('hidden');
    }

    const showNextBtn = function () {
        $nextBtn.removeClass('hidden');
        $resultBtn.addClass('hidden');
    }

    App.guru.onNextClick = function () {
        let $selectedAnswer = $slides.find('.slide:visible .btn.btn-check.active');

        if (!!$selectedAnswer.length) {
            if (typeof state.group === 'undefined') {
                setCurrentGroup($selectedAnswer.data('answer'));
            }

            setCurrentSlide(state.group, state.step);
            state.step = state.step + 1;

            if (state.step === state.stepTotal) {
                showResultBtn();
            }
        }
    }

    App.guru.onPrevClick = function () {
        let needStep = state.step - 1;

        if (needStep > 0) {
            state.step = needStep;
            setCurrentSlide(state.group, state.step - 1);
            showNextBtn();
            return true;
        }

        if (needStep === 0) {
            showStartSlide();
            return true;
        }

        if (state.step === 0 && window.App.getBreakpoint() === BreakpointsEnum.mobile) {
            $startCheckbox.trigger('click');
        }
    }

    App.guru.onResultClick = function ($this) {
        let $selectedAnswer = $slides.find('.slide:visible .btn.btn-check.active');

        if (!!$selectedAnswer.length) {
            let answers = $slides.find('.slide:not(.slide-start) .btn.btn-check.active').map(function () {
                return $(this).data('answer');
            }).get();

            window.location.href = queryString.stringifyUrl({
                url: $this.data('href'),
                query: {
                    'opros': state.group,
                    'question': answers
                }
            }, {
                arrayFormat: 'index'
            });
        }
    }

    $(document).on('click', '.answers .btn.btn-check', function () {
        let $this = $(this);

        if ($this.hasClass('active')) {
            $this.removeClass('active');
        } else {
            $this.closest('.slide').find('.btn.btn-check').removeClass('active');
            $this.addClass('active');
        }
    });
});